import axios from "../axios";

class SiteConfiguration {
    constructor() {
        this.list = "/template/site_configuration/list";
        this.addurl = "/template/site_configuration";
        this.detail = "/template/site_configuration/:id/";
        this.invalidate_cache = "template/site_configuration/invalidateCache";
    }
    getList(params) {
        return axios(this.list, { method: "get", params });
    }
    add(params) {
        return axios(this.addurl, { method: "post", params });
    }
    update(params) {
        return axios(this.detail, { method: "put", params });
    }
    getDetail(params) {
        return axios(this.detail, { method: "get", params });
    }
    invalidateSiteCache(id) {
        return axios(`${this.invalidate_cache}/${id}`, { method: "post" });
    }
}
export default new SiteConfiguration();



// WEBPACK FOOTER //
// ./src/api/modules/siteConfiguration.js